import Breadcrumb, { BreadcrumbType } from './Breadcrumb';
import ToTopScroll from '../atoms/ToTopScroll';

/**
 * コンポーネントのパラメータ定義。
 */
type Props = {
  // パンくずリストの表示情報
  // eslint-disable-next-line react/require-default-props
  breadcrumbs?: BreadcrumbType[];
};

/**
 * パンくずリストとページ上部スクロール導線をセットで表示する共通テンプレート。
 * @param param0 パンくず上書き情報
 * @returns パンくず表示領域
 */
const BreadcrumbLists = ({ breadcrumbs = [] }: Props) => {
  return (
    <div className='breadcrumbLists'>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <ToTopScroll />
    </div>
  );
};

export default BreadcrumbLists;
